module.exports = __webpack_public_path__ + "static/media/arrow-detail.942c5e13.svg";